/* eslint-disable */
(function ($, Drupal) {
  Drupal.behaviors.carouselSlick = {
    attach: function (context, settings) {
      // slider
      var $slick_slider = $('.carousel-mobile .view__content');
      var settings_slider = {
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: true,
        centerPadding: '40px',
      }
      slick_on_mobile($slick_slider, settings_slider);

      // slick on mobile
      function slick_on_mobile(slider, settings) {
        $(window).on('load resize', function () {
          if ($(window).width() > 767) {
            if (slider.hasClass('slick-initialized')) {
              slider.slick('unslick');
            }
            return
          }
          if (!slider.hasClass('slick-initialized')) {
            return slider.slick(settings);
          }
        });
      }

      //carrusel Especiales Editores
      $(".slick--carrusel-especiales-editores").slick({
        appendArrows: $('.nav'),
        appendDots: $('.nav .dots-container'),
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        prevArrow: '<div class="arrow-left"><i class="bi bi-arrow-left-short"></i></div>',
        nextArrow: '<div class="arrow-right"><i class="bi bi-arrow-right-short"></i></div>',
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              infinite: true,
            },
          },
        ]
      });

    }
  };
})(jQuery, Drupal);
